import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import ToggleButton from '../../../../ToggleButton';
import s from './ActionBarToggleButton.scss';
/**
 * Provides our `ToggleButton` with some additional ActionBar specific styling.
 */ const ActionBarToggleButton = (_param)=>/*#__PURE__*/ {
    var { className , activated , children , icon: Icon  } = _param, rest = _object_without_properties(_param, [
        "className",
        "activated",
        "children",
        "icon"
    ]);
    return React.createElement(ToggleButton, _extends({
        className: c(s['root'], className),
        icon: Icon,
        activated: activated
    }, rest));
};
ActionBarToggleButton.displayName = 'ActionBarToggleButton';
export default ActionBarToggleButton;
